import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { Row, Col, Modal } from "antd";
import { Switch } from "antd";
import { API_CREATE_SERVICE } from "api/service-managemnt";
import { useTranslation } from "react-i18next";
import { API_LIST_CATAGORY } from "api/catagory-managemnt";
import { API_CREATE_ITEM_SERVICE } from "api/item-services-managemnt";
import { PlusOutlined } from "@ant-design/icons";
import { Image, Upload } from "antd";
import { CONSTANTS } from "config/constant";
import { API_UPLOAD_IMAGE_ITEM_SERVICE } from "api/item-management";
import { API_UPDATE_ITEM_SERVICE } from "api/item-services-managemnt";
import { API_LIST_ITEM_SERVICE } from "api/item-services-managemnt";
import { API_UPDATE_ITEM } from "api/item-management";
import { useLocation, useNavigate } from "react-router-dom";
import { MdOutlineArrowBack } from "react-icons/md";
import Select from "react-select";

const EditItem = () => {
  const [data, setData] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  // const [selectedOptionItemService, setSelectedOptionItemService] =
  //   useState(null);
  const [selectedOptionItemService, setSelectedOptionItemService] = useState(
    []
  );

  const [serviceData, setServiceData] = useState([]);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false); // State for modal visibility
  const [valuesData, setValuesData] = useState(); // State for modal visibility
  const { t } = useTranslation();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [image, setImage] = useState();
  const [fileList, setFileList] = useState([
    // {
    //   uid: "-1",
    //   name: "image.png",
    //   status: "done",
    //   url: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
    // },
  ]);
  const location = useLocation();
  const Navigate = useNavigate();

  const dataItem = location.state && location.state.data;
  console.log("dataItem", dataItem);
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);

  const customRequest = async ({ file, onSuccess, onError }) => {
    try {
      // Create a FormData object
      const formData = new FormData();
      formData.append("images", file);
      const response = await API_UPLOAD_IMAGE_ITEM_SERVICE(formData);

      console.log("result", response, file);
      // Handle success
      const newFileList = [
        {
          uid: response.id, // Replace with the unique ID you receive from the server
          name: response?.file?.[0]?.name,
          status: "done",
          url: CONSTANTS?.IMG_DIRECTORY + response?.file?.[0]?.file_url, // Replace with the URL of the uploaded image
        },
      ];

      console.log(newFileList);
      setFileList(newFileList);
      // setImage(response?.file?.[0]);
      setImage(response?.file?.[0]);

      onSuccess();
      toast.success(response?.message);

      console.log("result", response);
      console.log("newFileList", newFileList);
    } catch (error) {
      toast.error(error?.message);
      // Handle exceptions and errors
      console.log("error", error);
      onError(error);
    }
  };
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );
  // const handleOptionChange = (event) => {
  //   const selectedIndex = event.target.value;
  //   console.log("selectedIndex",selectedIndex)
  //   setSelectedOption(data[selectedIndex]);
  // };
  const handleOptionChange = (event) => {
    const selectedCategoryId = event.target.value;
    const selectedIndex = data.findIndex(
      (category) => category._id === selectedCategoryId
    );
    if (selectedIndex !== -1) {
      setSelectedOption(data[selectedIndex]);
    } else {
      console.error("Category not found:", selectedCategoryId);
    }
  };

  const handleOptionChangeItem = (selectedOptions) => {
    setSelectedOptionItemService(selectedOptions);
  };
  console.log("selected items services", selectedOptionItemService);
  // const handleOptionChangeItem = (event) => {
  //   const selectedItemServiceId = event.target.value;
  //   const selectedIndex = serviceData.findIndex(
  //     (service) => service._id === selectedItemServiceId
  //   );
  //   if (selectedIndex !== -1) {
  //     setSelectedOptionItemService(serviceData[selectedIndex]);
  //   } else {
  //     console.error("Item service not found:", selectedItemServiceId);
  //     // Reset selected option or handle the error as needed
  //   }
  // };

  const options = serviceData?.map((option) => ({
    value: option._id,
    label: option.name,
  }));

  // const handleOptionChangeItem = (event) => {
  //   const selectedIndex = event.target.value;
  //   console.log("selectedIndex", selectedIndex);
  //   setSelectedOptionItemService(serviceData[selectedIndex]);
  // };

  const fetchData = async () => {
    try {
      const params = {
        page: "",
        limit: "",
        name: "",
      };
      const newData = await API_LIST_CATAGORY(params);
      setData(newData?.categories);
      // setServiceData(newData?.categories);

      // Pre-select category if available in dataItem
      const selectedCategory = newData?.categories.find(
        (cat) => cat._id === dataItem?.category?._id
      );
      console.log("selectedCategory", selectedCategory);
      if (selectedCategory) {
        setSelectedOption(selectedCategory);
      }

      // Pre-select category if available in dataItem
      // const selectedItem = dataItem?.item_service?.find(
      //   (cat) => cat?.item_service === cat?.service_info?._id
      // );
      // console.log("selectedItem", selectedItem);
      // if (selectedItem) {
      //   setSelectedOptionItemService(selectedItem?.service_info);
      // }

      // Pre-select item services if available in dataItem
      const selectedItems = dataItem?.item_service
        ?.map((item) => ({
          value: item?.service_info?._id,
          label: item?.service_info?.name,
          // label: serviceData.find(
          //   (service) => service._id === item?.service_info?._id
          // )?.name,
        }))
        .filter((item) => item.value);

      console.log("selectedItems", selectedItems);
      if (selectedItems) {
        setSelectedOptionItemService(selectedItems);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchDatas = async () => {
    try {
      const params = {
        page: "",
        limit: "",
        name: "",
      };
      const newData = await API_LIST_ITEM_SERVICE(params);
      console.log("newData", newData);

      setServiceData(newData?.item_services);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const params = {
  //         page: "",
  //         limit: "",
  //         name: "",
  //       };
  //       const newData = await API_LIST_CATAGORY(params);
  //       setData(newData?.categories);
  //       setServiceData(newData?.categories);

  //       // Pre-select category if available in dataItem
  //       const selectedCategory = newData?.categories.find(cat => cat._id === dataItem?.category);
  //       console.log("selectedCategory",selectedCategory)
  //       if (selectedCategory) {
  //         setSelectedOption(selectedCategory);
  //       }

  //       // Pre-select item service if available in dataItem
  //       if (dataItem?.item_service && dataItem.item_service.length > 0) {
  //         const selectedItemService = selectedCategory?.item_service.find(service => service._id === dataItem.item_service[0].item_service);
  //         if (selectedItemService) {
  //           setSelectedOptionItemService(selectedItemService);
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  //   };

  //   fetchData();
  // }, [dataItem]);

  // useEffect(() => {
  //   fetchData();
  // }, []);
  // let item_service = dataItem?.item_service;
  // // setSelectedOptionItemService(item_service);
  useEffect(() => {
    fetchData();
    fetchDatas();
  }, [dataItem]);
  useEffect(() => {
    if (dataItem?.images?.[0]?.file_url) {
      setFileList([
        {
          uid: "-1",
          name: "image.png",
          status: "done",
          url: CONSTANTS?.IMG_DIRECTORY + dataItem?.images?.[0]?.file_url,
        },
      ]);
    }
  }, [dataItem]);
  useEffect(() => {
    setImage(dataItem?.images?.[0]);
  }, [dataItem]);

  console.log("dataItem", dataItem);
  console.log("selectedOptionItemService", selectedOptionItemService);
console.log("fileList",fileList)
console.log("imagesss",image)
  return (
    <>
      <div className=" mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
          <Formik
            initialValues={{
              name: dataItem?.name,
              description: dataItem?.description,
              category: dataItem?.category,
              // price: dataItem?.item_service?.[0]?.price,
              item_service:
                dataItem?.item_service?.map((service) => ({
                  item_service: service?._id, // Assuming _id is the unique identifier for item_service
                  price: service?.price || "", // Adjust according to your actual data structure
                })) || [],
              // item_service:
              //   selectedOptionItemService?.map((item) => ({
              //     item_service: item.value,
              //     price:
              //       dataItem?.item_service?.find(
              //         (service) => service.item_service === item.value
              //       )?.price || "",
              //   })) || [],
              images: image,
            }}
            validationSchema={Yup.object({
              name: Yup.string()
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(50, "Maximum character should be 50"),
              description: Yup.string()
                .required("Required")
                .test(
                  "max-words",
                  "Description must be at most 150 words",
                  (value) => value.trim().split(/\s+/).length <= 150
                ),
              selectedOptionItemService: Yup.array().min(
                1,
                "At least one service must be selected"
              ),

              // item_service: Yup.array().of(
              //   Yup.object().shape({
              //     price: Yup.number()
              //       .required("Price is required")
              //       .positive("Price must be positive")
              //       .typeError("Price must be a number"),
              //   })
              // ),
              // price: Yup.string().required("Required"),

              // category: Yup.string().required("Required"),
            })}
            // validationSchema={Yup.object({
            //   name: Yup.string()
            //     .required("Required")
            //     .matches(/^[^\d]+$/, "Name cannot contain numbers")
            //     .max(20, "Maximum character should be 20"),
            //   description: Yup.string()
            //     .required("Required")
            //     .test(
            //       "max-words",
            //       "Description must be at most 150 words",
            //       (value) => value.trim().split(/\s+/).length <= 150
            //     ),
            //   price: Yup.string().required("Required"),

            //   // category: Yup.string().required("Required"),
            // })}
            onSubmit={async (values, { setSubmitting, setFieldError }) => {
              setValuesData(values);
              setConfirmModalVisible(true);
              // try {
              //   const { category, images, ...data } = values;

              //   const payload = {
              //     ...data,
              //     category: selectedOption?._id,
              //     images: image,

              //     item_service: [
              //       {
              //         item_service: selectedOptionItemService?._id,
              //         price: values?.price,
              //       },
              //     ],
              //   };

              //   let s = await API_UPDATE_ITEM(payload, dataItem?._id);
              //   Navigate("/admin/items/item-tables");

              //   toast.success(s?.message);
              // } catch (error) {
              //   console.error("error", error);
              //   toast.error(error?.response?.data?.message);
              // } finally {
              //   setSubmitting(false);
              // }
            }}
          >
            {({ isSubmitting, values, setFieldValue }) => (
              <Form className="flex min-h-[36rem] w-full flex-col justify-between rounded-[20px] bg-white p-8 pt-0 shadow-md">
                <div
                  className="flex cursor-pointer items-center gap-2"
                  onClick={() => {
                    Navigate(-1);
                  }}
                >
                  <MdOutlineArrowBack
                    className="cursor-pointer"
                    style={{ fontSize: "17px" }}
                  />
                  <p>{t("Back")}</p>
                </div>
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    {/* Images */}
                    <div className="mb-3 flex justify-center">
                      <Upload
                        action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                        listType="picture-circle"
                        customRequest={customRequest}
                        fileList={fileList}
                        onPreview={handlePreview}
                        onChange={handleChange}
                      >
                        {fileList.length == 1 ? null : uploadButton}
                      </Upload>
                      {previewImage && (
                        <Image
                          wrapperStyle={{
                            display: "none",
                          }}
                          preview={{
                            visible: previewOpen,
                            onVisibleChange: (visible) =>
                              setPreviewOpen(visible),
                            afterOpenChange: (visible) =>
                              !visible && setPreviewImage(""),
                          }}
                          src={previewImage}
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  {/* Existing fields */}
                  <Col span={12}>
                    {/* Service Name */}
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Service Name")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="name"
                        placeholder={t("Name")}
                        maxLength={50}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={12}>
                    {/* Select Category */}
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Select Category")}{" "}
                        <span className="text-[red]">*</span>
                      </label>
                      <select
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        onChange={handleOptionChange}
                        name="category"
                        value={selectedOption?._id} // Set the value to category ID

                        // value={ selectedOption?.name }
                      >
                        <option value="">{t("Select an option")}</option>
                        {data?.map((option, index) => (
                          <option key={option?._id} value={option?._id}>
                            {option.title}
                          </option>
                        ))}
                      </select>
                      <ErrorMessage
                        name="category"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  {/* New fields */}
                  {/* <Col span={12}>
                    <div className="mb-3">
                      <label>
                        {t("Item Service Price")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        type="text"
                        name="price"
                        placeholder={t("Item Service Price")}
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;
                          const keyValue = String.fromCharCode(keyCode);
                          const regex = /^[0-9]+$/;
                          if (!regex.test(keyValue)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="price"
                        component="div"
                        className="text-red-500"
                      />
                    </div>{" "}
                  </Col> */}

                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Select Item Service")}{" "}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <select
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        onChange={handleOptionChangeItem}
                        name="item_service"
                        value={selectedOptionItemService?._id || ""}
                      >
                        <option value="">Select an option</option>
                        {serviceData?.map((option) => (
                          <option key={option._id} value={option._id}>
                            {option.name}
                          </option>
                        ))}
                      </select> */}

                      <Select
                        // className="mt-2 w-full text-sm"
                        className="mt-2 flex h-11 w-full items-center  rounded-xl  border-2 border-gray-300 bg-white p-3  text-sm outline-none"
                        onChange={handleOptionChangeItem}
                        options={options}
                        isMulti
                        placeholder={t("Select options")}
                        value={selectedOptionItemService}
                      />

                      {/* <select
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        onChange={handleOptionChangeItem}
                        name="item_service"
                        value={dataItem?.item_service?.service_info?.name}
                      >
                        <option value="">Select an option</option>
                        {serviceData?.map((option, index) => (
                          <option key={index} value={index}>
                            {console.log("option==>", option)}
                            {option?.name}
                          </option>
                        ))}
                      </select> */}
                      <ErrorMessage
                        name="item_service"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={12}>
                    {/* Service Description */}
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Description")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        as="textarea"
                        name="description"
                        placeholder={t("Description")}
                      />
                      <ErrorMessage
                        name="description"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={12} className="relative bottom-[45px]">
                    {/* Dynamic Price Fields */}
                    <FieldArray name="item_service">
                      {({ remove, push }) => (
                        <>
                          {selectedOptionItemService?.length > 0 &&
                            selectedOptionItemService?.map((item, index) => (
                              <div className="mr-3 w-full">
                                <label className="font-semibold">
                                  {`Service ${item?.label} Price`}
                                  {/* <span className="text-[red]">*</span> */}
                                </label>
                                <Field
                                  className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                                  name={`item_service.${index}.price`}
                                  placeholder={`Service ${index + 1} Price`}
                                />
                                <ErrorMessage
                                  name={`item_service.${index}.price`}
                                  component="div"
                                  className="mt-1 text-sm text-red-500"
                                />
                              </div>
                            ))}
                        </>
                      )}
                    </FieldArray>
                  </Col>
                </Row>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="linear mt-2 w-full max-w-[10rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    {isSubmitting ? t("Updating") + "..." : t("Update Item")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
          {/* Confirmation Modal */}
          <Modal
            // title="Save Changes"
            visible={confirmModalVisible}
            onCancel={() => setConfirmModalVisible(false)}
            centered
            onOk={async () => {
              setConfirmModalVisible(false);
              try {
                const { category, images, ...data } = valuesData;
                const payload = {
                  ...data,
                  category: selectedOption?._id,
                  images: image ? image : fileList,
                  item_service: selectedOptionItemService?.map(
                    (option, index) => ({
                      item_service: option?.value,
                      price: valuesData.item_service[index]?.price || "",
                    })
                  ),
                  // item_service: [
                  //   {
                  //     item_service: selectedOptionItemService?._id,
                  //     price: valuesData?.price,
                  //   },
                  // ],
                };

                let s = await API_UPDATE_ITEM(payload, dataItem?._id);
                Navigate("/admin/items/item-tables");

                toast.success(s?.message);
              } catch (error) {
                console.error("error", error);
                toast.error(error?.response?.data?.message);
              } finally {
                // setSubmitting(false);
              }
            }}
          >
            <div
              className="flex items-center"
              style={{ flexDirection: "column" }}
            >
              <div>
                <p className="mb-1 font-bold">{t("Save Changes")}</p>
                <p className="mb-8 font-medium">
                  {t("Do you want to Save Changes before leaving the Page?")}
                </p>
              </div>
              <div className="flex gap-4">
                <button
                  className="linear text-black mt-2 w-full  rounded-xl py-[12px] text-base font-medium transition duration-200  dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  onClick={() => setConfirmModalVisible(false)}
                  style={{ width: "6rem" }}
                >
                  {t("Cancel")}
                </button>
                <button
                  className="linear mt-2 w-full max-w-[10rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  onClick={async () => {
                    setConfirmModalVisible(false);
                    try {
                      const { category, images, ...data } = valuesData;
                      const payload = {
                        ...data,
                        category: selectedOption?._id,
                        // images: image,
                        images: image ? image : fileList,

                        item_service: selectedOptionItemService?.map(
                          (option, index) => ({
                            item_service: option?.value,
                            price: valuesData.item_service[index]?.price || "",
                          })
                        ),
                        // item_service: [
                        //   {
                        //     item_service: selectedOptionItemService?._id,
                        //     price: valuesData?.price,
                        //   },
                        // ],
                      };

                      let s = await API_UPDATE_ITEM(payload, dataItem?._id);
                      Navigate("/admin/items/item-tables");

                      toast.success(s?.message);
                    } catch (error) {
                      console.error("error", error);
                      toast.error(error?.response?.data?.message);
                    } finally {
                      // setSubmitting(false);
                    }
                  }}
                >
                  {t("Save Changes")}
                </button>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default EditItem;
